import React, { useState, useEffect, forwardRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
// import InputMask from 'react-input-mask';
import OriginalInputMask from 'react-input-mask';
import 'react-datepicker/dist/react-datepicker.css';
import './form_cadastro.css';


function FormCadastro() {

const InputMask = forwardRef((props, ref) => {
    return <OriginalInputMask {...props} inputRef={ref} />;
    });

const [cep, setCep] = useState('');
const [endereco, setEndereco] = useState('');
const [jaFezEnem, setJaFezEnem] = useState(false);
const [numeroCasa, setNumeroCasa] = useState('');
const [cepValid, setCepValid] = useState(false);
const [celularValid, setCelularValid] = useState(false);
const [dataValid, setDataValid] = useState(false);
const [validationErrors, setValidationErrors] = useState({
    cep: '',
    celular: '',
    data: ''
});

const [modalidades, setModalidades] = useState([]);
const [grupos, setGrupos] = useState([]);
const [instituicoes, setInstituicoes] = useState([]);
const [enems, setEnems] = useState([]);

const [notasEnem, setNotasEnem] = useState({
    cienciaNatureza: '',
    matematica: '',
    cienciasHumanas: '',
    linguagens: '',
    redacao: '',
});

const [selectedDate, setSelectedDate] = useState(null);
const [mensagem, setMensagem] = useState('');
const [section, setSection] = useState(1);

const [nome, setNome] = useState('');
const [cpf, setCpf] = useState('');
const [rg, setRg] = useState('');
const [celular, setCelular] = useState('');
const [email, setEmail] = useState('');
const [senha, setSenha] = useState('');
const [confirmarSenha, setConfirmarSenha] = useState('');
const [complemento, setComplemento] = useState('');

const [modalidadeSelecionada, setModalidadeSelecionada] = useState('');
const [grupoSelecionado, setGrupoSelecionado] = useState('');
const [instituicaoSelecionada, setInstituicaoSelecionada] = useState('');
const [enemSelecionado, setEnemSelecionado] = useState('');



    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const [modalidadeRes, grupoRes, instituicaoRes, enemRes] = await Promise.all([
                    fetch('https://rveducacao.com.br/get.php?action=getModalidades'),
                    fetch('https://rveducacao.com.br/get.php?action=getGrupos'),
                    fetch('https://rveducacao.com.br/get.php?action=getInstituicoes'),
                    fetch('https://rveducacao.com.br/get.php?action=get_enem_aplicacoes')
                ]);
    
                const modalidadesData = await modalidadeRes.json();
                const gruposData = await grupoRes.json();
                const instituicoesData = await instituicaoRes.json();
                const enemsData = await enemRes.json()
    
                setModalidades(modalidadesData);
                setGrupos(gruposData);
                setInstituicoes(instituicoesData);
                setEnems(enemsData)
                
            } catch (error) {
                console.error('Erro ao buscar os dados dos dropdowns:', error);
            }
        };
    
        fetchDropdownData();
    }, []);
    

    const navigate = useNavigate();

    const nextSection = () => {
        const form = document.querySelector('.cadastro');
        if (cepValid && form.checkValidity()) {
            setSection((prev) => prev + 1);
        } else {
            form.reportValidity();
        }
    };
    
    
    const prevSection = () => {
        setSection((prev) => prev - 1);
    };    

    const validateCep = (cep) => {
        const cepRegex = /^\d{8}$/;
        return cepRegex.test(cep);
    };

    const validateCelular = (celular) => {
        // Remove todos os caracteres não numéricos
        const numeroLimpo = celular.replace(/\D/g, '');
        // Verifica se tem entre 10 e 11 dígitos (com ou sem DDD)
        return numeroLimpo.length >= 10 && numeroLimpo.length <= 11;
    };

    const validateData = (date) => {
        if (!date) return false;
        
        const hoje = new Date();
        const dataNascimento = new Date(date);
        
        // Verifica se a data é válida
        if (isNaN(dataNascimento.getTime())) return false;
        
        // Verifica se a data não é futura
        if (dataNascimento > hoje) return false;
        
        // Verifica se a pessoa tem pelo menos 15 anos
        let idade = hoje.getFullYear() - dataNascimento.getFullYear();
        const mes = hoje.getMonth() - dataNascimento.getMonth();
        if (mes < 0 || (mes === 0 && hoje.getDate() < dataNascimento.getDate())) {
            idade--;
        }
        return idade >= 15;
    };

    const handleCepChange = async (e) => {
        const newCep = e.target.value.replace(/\D/g, '');
        setCep(newCep);

        if (validateCep(newCep)) {
            try {
                const response = await fetch(`https://viacep.com.br/ws/${newCep}/json/`);
                if (!response.ok) {
                    throw new Error('Erro na API de CEP');
                }

                const data = await response.json();

                if (data.erro) {
                    setEndereco('CEP inválido');
                    setCepValid(false);
                    setValidationErrors(prev => ({...prev, cep: 'CEP não encontrado'}));
                } else {
                    const enderecoCompleto = `${data.logradouro}, ${data.bairro}, ${data.localidade} - ${data.uf}`;
                    setEndereco(enderecoCompleto);
                    setCepValid(true);
                    setValidationErrors(prev => ({...prev, cep: ''}));
                }
            } catch (error) {
                console.error('Erro ao buscar o endereço:', error);
                setEndereco('Erro ao buscar endereço');
                setCepValid(false);
                setValidationErrors(prev => ({...prev, cep: 'Erro ao buscar CEP'}));
            }
        } else {
            setEndereco('');
            setCepValid(false);
            setValidationErrors(prev => ({...prev, cep: ''}));
        }
    };

    const handleCelularChange = (e) => {
        const newCelular = e.target.value;
        setCelular(newCelular);
        const isValid = validateCelular(newCelular);
        setCelularValid(isValid);
        setValidationErrors(prev => ({
            ...prev, 
            celular: isValid ? '' : ''
        }));
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
        const isValid = validateData(date);
        setDataValid(isValid);
        setValidationErrors(prev => ({
            ...prev, 
            data: isValid ? '' : ''
        }));
    };
    
    

    const handleNumeroCasaChange = (e) => {
        let value = e.target.value;
    
        // Permitir valor vazio para facilitar a digitação
        if (value === '') {
            setNumeroCasa('');
            return;
        }
    
        // Converte para inteiro
        value = parseInt(value, 10);
    
        // Se o valor for negativo, define como 0
        if (value < 0) value = 0;
    
        setNumeroCasa(value);
    };
    
    const handleEnderecoChange = (e) => {
        setEndereco(e.target.value);
    };

    const handleNotasChange = (e) => {
        const { name, value } = e.target;
        let validatedValue = value;
    
        // Permitir valor vazio para facilitar a digitação
        if (validatedValue === '' || validatedValue === '0') {
            setNotasEnem((prevNotas) => ({
                ...prevNotas,
                [name]: validatedValue,
            }));
            return;
        }
    
        // Converter o valor para número inteiro
        validatedValue = parseInt(validatedValue, 10);
    
        // Garantir os limites mínimo e máximo
        if (validatedValue < 0) validatedValue = 0;
        if (validatedValue > 1200) validatedValue = 1200;
    
        setNotasEnem((prevNotas) => ({
            ...prevNotas,
            [name]: validatedValue,
        }));
    };
    

    const handleCadastro = async (e) => {
        e.preventDefault();
    
        // Validações antes do envio
        if (!validateCep(cep)) {
            setMensagem('CEP inválido');
            return;
        }

        if (!validateCelular(celular)) {
            setMensagem('Número de celular inválido');
            return;
        }

        if (!validateData(selectedDate)) {
            setMensagem('Data de nascimento inválida');
            return;
        }

        try {
            // Construindo a URL para a requisição de adicionar aluno
            const urlAdicionarAluno = `https://rveducacao.com.br/get.php?action=adicionarAluno&nome=${encodeURIComponent(nome)}&CPF=${cpf}&RG=${rg}&nascimento=${selectedDate ? format(selectedDate, 'yyyy-MM-dd') : ''}&CEP=${cep}&logradouro=${encodeURIComponent(endereco)}&numero=${numeroCasa}&complemento=${encodeURIComponent(complemento)}&celular=${celular}&email=${encodeURIComponent(email)}&senha=${encodeURIComponent(senha)}&modalidade=${encodeURIComponent(modalidadeSelecionada)}&grupo=${encodeURIComponent(grupoSelecionado)}&instituicao=${encodeURIComponent(instituicaoSelecionada)}`;
    
            // Primeira requisição: Adicionar aluno
            const response = await fetch(urlAdicionarAluno);
            const data = await response.json();
    
            if (data.status === "success") {
                setMensagem(data.message); // Exibir mensagem da API
    
                // Se o usuário indicou que já fez ENEM, faz a segunda requisição
                if (jaFezEnem) {
                    const matricula = data.matricula; // Pegando a matrícula retornada
                    const notas = `{${notasEnem.cienciaNatureza},${notasEnem.matematica},${notasEnem.cienciasHumanas},${notasEnem.linguagens},${notasEnem.redacao}}`;
    
                    const urlAdicionarResultado = `https://rveducacao.com.br/get.php?action=adicionarResultadoENEM&matricula=${matricula}&concurso=${encodeURIComponent(enemSelecionado)}&notas=${notas}`;
    
                    // Segunda requisição: Adicionar notas do ENEM
                    const responseNotas = await fetch(urlAdicionarResultado);
                    const dataNotas = await responseNotas.json();
    
                    if (dataNotas.status === 1) {
                        // caso de sucesso
                        setMensagem(`${data.message}`);
                    } else {
                        setMensagem(`${data.message}`);
                    }
                }
    
                // Redirecionar após 2 segundos
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            } else {
                console.error("Erro ao cadastrar usuário:", data);
                setMensagem(data.message || "Erro ao cadastrar usuário.");
            }
        } catch (error) {
            console.error("Erro durante o cadastro:", error);
            setMensagem("Erro ao conectar ao servidor.");
        }
    };
    
    

    return (
        <div className='page-container login'>
            <div className='login-container signup'>
                <form onSubmit={handleCadastro} className='cadastro'>
                    <div className="arrow-back cadastro">
                        <Link to="/login" className="no-link-style">
                            {/* <span className="arrow">&larr;</span> */}
                            <ArrowBackOutlinedIcon style={{ color: '#fff', fontSize: 35 }} className='sidebar-icon custom-arrow-icon' />
                        </Link>
                    </div>
                    
                    <Link to="/login" className="no-link-style">
                        <img src="https://rveducacao.com.br/230616_RV_logo_principal_positivo-cor.png" alt="Logo" className={`login-logo ${section === 1 ? 'cadastro' : ''}`}  />
                    </Link>

                    {/* Seção 1 */}
                
                    {section === 1 && (
                    <div className='inputs'>
                        <h3 className='inputs-header'>Dados Pessoais</h3>
                        <input
                            type="text"
                            placeholder="Nome Completo"
                            id="nome"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            required
                        />

                        {/* <InputMask
                mask="999.999.999-99"
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
              >
                {(inputProps) => (
                  <input
                    {...inputProps}
                    type="text"
                    placeholder="CPF"
                    id="cpf"
                    required
                  />
                )}
              </InputMask> */}
              <input
                type="text"
                placeholder="CPF"
                id="cpf"
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
                required
              />

              {/* <InputMask
                mask="99.999.999-9"
                value={rg}
                onChange={(e) => setRg(e.target.value)}
              >
                {(inputProps) => (
                  <input
                    {...inputProps}
                    type="text"
                    placeholder="RG"
                    id="rg"
                    required
                  />
                )}
              </InputMask> */}
              <input
                type="text"
                placeholder="RG"
                id="rg"
                value={rg}
                onChange={(e) => setRg(e.target.value)}
                required
              />

                        <div className="input-group">
                            <DatePicker
                                selected={selectedDate}
                                onChange={handleDateChange}
                                placeholderText="Data de Nascimento"
                                dateFormat="dd/MM/yyyy"
                                className={`custom-datepicker ${dataValid ? 'valid' : selectedDate ? 'invalid' : ''}`}
                                required
                            />
                            {validationErrors.data && <span className="error-message">{validationErrors.data}</span>}
                        </div>

                        <div className="input-group">
                            {/* <InputMask
                                mask="99999-999"
                                value={cep}
                                onChange={handleCepChange}
                                placeholder="CEP"
                                className={cepValid ? 'valid' : cep ? 'invalid' : ''}
                                required
                            >
                                {(inputProps) => (
                                    <input
                                        {...inputProps}
                                        type="text"
                                        placeholder="CEP"
                                        className={cepValid ? 'valid' : cep ? 'invalid' : ''}
                                        required
                                    />
                                )}
                            </InputMask> */}
                            <input
                                type="text"
                                placeholder="CEP"
                                id="cep"
                                value={cep}
                                onChange={handleCepChange}
                                className={cepValid ? 'valid' : cep ? 'invalid' : ''}
                                required
                            />
                            {validationErrors.cep && <span className="error-message">{validationErrors.cep}</span>}
                        </div>

                        <input
                            type="text"
                            placeholder="Endereço"
                            id="endereco"
                            value={endereco}
                            onChange={handleEnderecoChange}
                            required={cepValid}
                            readOnly
                        />


                        <input
                            type="number"
                            placeholder="Número"
                            id="numero"
                            value={numeroCasa}
                            onChange={handleNumeroCasaChange}
                            required
                        />


                        <input
                            type="text"
                            placeholder="Complemento"
                            id="complemento"
                            value={complemento}
                            onChange={(e) => setComplemento(e.target.value)}
                        />


                        <div className="input-group">
                            {/* <InputMask
                                mask="(99) 99999-9999"
                                value={celular}
                                onChange={handleCelularChange}
                                placeholder="Celular"
                                className={celularValid ? 'valid' : celular ? 'invalid' : ''}
                                required
                            >
                                {(inputProps) => (
                                    <input
                                        {...inputProps}
                                        type="tel"
                                        placeholder="Celular"
                                        className={celularValid ? 'valid' : celular ? 'invalid' : ''}
                                        required
                                    />
                                )}
                            </InputMask> */}
                            <input
                                type="tel"
                                placeholder="Celular"
                                id="celular"
                                value={celular}
                                onChange={handleCelularChange}
                                className={celularValid ? 'valid' : celular ? 'invalid' : ''}
                                required
                            />
                            {validationErrors.celular && <span className="error-message">{validationErrors.celular}</span>}
                        </div>

                        {/* <div className='button' onClick={nextSection()}>Avançar</div> */}

                    </div>

                    )}



                    {/* Seção 2 */}
                    {section === 2 && (
                        <div>
                            <h3 className='inputs-header'>Histórico Escolar</h3>
                            {/* <div>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    Já fez Enem?

                                    <input
                                        type="checkbox"
                                        checked={jaFezEnem}
                                        onChange={() => setJaFezEnem(!jaFezEnem)}
                                        style={{
                                            transform: 'scale(0.7)',
                                            position: 'relative',
                                            top: '-12px',
                                        }}
                                    />                                    
                                </label>
                            </div> */}


                        <div className='selects-cadastro-container'>

                            <div className="select-wrapper">
                                <select id="modalidade" required className='select-cadastro' 
                                value={modalidadeSelecionada}
                                onChange={(e) => setModalidadeSelecionada(e.target.value)}>
                                    <option value="" className='option'>Modalidade</option>
                                    {modalidades.map((modalidade) => (
                                        <option key={modalidade} value={modalidade} className='option'>
                                            {modalidade}
                                        </option>
                                    ))}
                                </select>
                                <div className="select-arrow"></div>
                            </div>

                            <div className="select-wrapper">
                                <select id="grupo" required className='select-cadastro' value={grupoSelecionado}
                                    onChange={(e) => setGrupoSelecionado(e.target.value)} >
                                    <option value="" className='option'>Grupo</option>
                                    {grupos.map((grupo) => (
                                        <option key={grupo} value={grupo} className='option'>
                                            {grupo}
                                        </option>
                                    ))}
                                </select>
                                <div className="select-arrow"></div>
                            </div>

                            <div className="select-wrapper">
                                <select id="instituicao" required className='select-cadastro' value={instituicaoSelecionada}
                                    onChange={(e) => setInstituicaoSelecionada(e.target.value)}>
                                    <option value="" className='option'>Instituição</option>
                                    {instituicoes.map((instituicao) => (
                                        <option key={instituicao} value={instituicao} className='option'>
                                            {instituicao}
                                        </option>
                                    ))}
                                </select>
                                <div className="select-arrow"></div>
                            </div>
                        </div>


                            <div className="slider-container">

                            
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={jaFezEnem}
                                    onChange={() => setJaFezEnem(!jaFezEnem)}
                                    
                                />
                                <span className="slider round"></span>
                            </label>
                            <span className='slider-label'>Já fez Enem?</span>
                        </div>

                            {jaFezEnem && (
                                <div className="notas-enem">
                                    <label>Coloque seu desempenho na prova:</label>

                                    {/* select enem aqui */}
                                    <select id="modalidade" required className='select-cadastro' 
                                        value={enemSelecionado}
                                        onChange={(e) => setEnemSelecionado(e.target.value)}>
                                            <option value="" className='option'>Prova</option>
                                            {enems.map((enem) => (
                                                <option key={enem} value={enem} className='option'>
                                                    {enem}
                                                </option>
                                            ))}
                                        </select>

                                    <input
                                        type="number"
                                        placeholder="Ciências da Natureza"
                                        name="cienciaNatureza"
                                        value={notasEnem.cienciaNatureza}
                                        onChange={handleNotasChange}
                                        required
                                    />
                                    <input
                                        type="number"
                                        placeholder="Matemática"
                                        name="matematica"
                                        value={notasEnem.matematica}
                                        onChange={handleNotasChange}
                                        required
                                    />
                                    <input
                                        type="number"
                                        placeholder="Ciências Humanas"
                                        name="cienciasHumanas"
                                        value={notasEnem.cienciasHumanas}
                                        onChange={handleNotasChange}
                                        required
                                    />
                                    <input
                                        type="number"
                                        placeholder="Linguagens"
                                        name="linguagens"
                                        value={notasEnem.linguagens}
                                        onChange={handleNotasChange}
                                        required
                                    />
                                    <input
                                        type="number"
                                        placeholder="Redação"
                                        name="redacao"
                                        value={notasEnem.redacao}
                                        onChange={handleNotasChange}
                                        required
                                    />
                                </div>
                            )}

                            {/* <div className='button' onClick={nextSection()}>Avançar</div> */}
                        </div>
                    )}


                    {/* Seção 3 */}
                    {section === 3 && (
                        <div className='inputs'>
                            <h3 className='inputs-header'>Email e Senha</h3>
                            <input
                                type="text"
                                placeholder="Email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <input
                                type="password"
                                placeholder="Senha"
                                id="password"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                required
                            />
                            <input
                                type="password"
                                placeholder="Confirmar Senha"
                                id="confirm_password"
                                value={confirmarSenha}
                                onChange={(e) => setConfirmarSenha(e.target.value)}
                                required
                            />
        
                        </div>

                    )}

<div className="button-container">
    {section === 1 && (
        <button type="button" onClick={nextSection} className="button">
            Avançar
        </button>
    )}

    {section === 2 && (
        <div className='buttons-half'>
            <button type="button half" onClick={nextSection} className="button">
                Avançar
            </button>
            <button type="button half" onClick={prevSection} className="link-cadastro">
                Voltar
            </button>
        </div>
    )}

    {section === 3 && (
        <>
        <button type="submit" className="button">
            Cadastrar
        </button>
        <button type="button half" onClick={prevSection} className="link-cadastro">
                Voltar
        </button>
        </>
    )}
</div>


                    
                    {/* <button className='button' type="submit">Cadastrar</button> */}


                    {mensagem && <p className="mensagem-sucesso">{mensagem}</p>}
                </form>
            </div>
        </div>
    );
}

export default FormCadastro;
